import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqFileLogService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-file-logs', query);
  }

  create(body: any) {
    return this.post('/cq-file-logs', body);
  }

  find(id) {
    return this.get('/cq-file-logs/' + id);
  }

  update(id, body) {
    return this.put('/cq-file-logs/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-file-logs/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqFileLog.service.ts